import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnimalSelectionDetailsComponent } from './animal-selection-details.component';
import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@ngneat/transloco';
import { DetailsCardLayoutModule } from '@tcc-mono/shared/ui/details-card-layout';
import { DetailsTableModule } from '@tcc-mono/shared/ui/details-table';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SubscribeDirective } from '@ngneat/subscribe';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    DetailsCardLayoutModule,
    TranslocoModule,
    DetailsTableModule,
    FontAwesomeModule,
    SubscribeDirective
  ],
  declarations: [AnimalSelectionDetailsComponent],
  exports: [AnimalSelectionDetailsComponent]
})
export class AnimalSelectionDetailsModule {}
